module.exports = __webpack_public_path__ + "img/universal-logo-white.64415ff2.png";